import { render, staticRenderFns } from "./FrontPageContentFormScreen.vue?vue&type=template&id=1b256842&"
import script from "./FrontPageContentFormScreen.vue?vue&type=script&lang=ts&"
export * from "./FrontPageContentFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports